/*eslint-disable*/
export const messages = {
  // System notices (truncation / safety refusal)
  "This answer was shortened because it reached the length limit and may be incomplete.": "Этот ответ был сокращён, так как достигнут предел длины, и может быть неполным.",
  "This request can't be answered due to safety guidelines. Please rephrase or ask about a different topic.": "На этот запрос нельзя ответить из-за правил безопасности. Переформулируйте его или спросите о другой теме.",
  "Cancel": "Отмена",
  "Change theme": "Изменить тему",
  "Clear chat": "Очистить чат",
  "Clear chat history": "Очистить историю чата",
  "Connecting...": "Соединение...",
  "Continue": "Продолжить",
  "Decrease font size": "Уменьшить размер шрифта",
  "Disclaimer": "Отказ от ответственности",
  "Enter your message...": "Введите ваше сообщение...",
  "Type your message...": "Введите ваше сообщение...",
  "Error": "Ошибка",
  "Font size": "Размер шрифта",
  "Increase font size": "Увеличить размер шрифта",
  "Language": "Язык",
  "MJ Lab": "Лаборатория MJ",
  "Reset font size": "Сбросить размер шрифта",
  "Respond time: {time}s": "Время ответа: {time} с",
  "Response time:": "Время ответа:",
  "Send": "Отправить",
  "Settings": "Настройки",
  "Support the project": "Поддержать проект",
  "System": "Система",
  "Theme": "Тема",
  "Thinking...": "Обдумывание...",
  "Toggle theme": "Переключить тему",
  "Welcome to {{name}} by MJ": "Добро пожаловать в {{name}} от MJ",
  "You asked:": "Вы спросили:",
  
  // Headers
  "Ministry of Commerce Laws Expert": "Эксперт по законам MoC",
  "by MJ": "от MJ",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "Здравствуйте, я {{name}}, ИИ-ассистент, созданный MJ.",
  "I am expert in Ministry of Commerce laws and regulations for Saudi Arabia.": "Я эксперт по законам и нормативным актам Министерства торговли Саудовской Аравии.",
  "Ask me a question, and I will gladly answer you.": "Задайте мне вопрос, и я с радостью вам отвечу.",
  "Do not share confidential data.": "Не делитесь конфиденциальными данными.",
  "I am powered using": "Я работаю на основе",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi Ministry of Commerce laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**Отказ от ответственности:** {{name}} - это экспериментальный ИИ-ассистент, созданный для ответов на основе данных из законов и нормативных актов Министерства торговли Саудовской Аравии, избегая предположений и неточностей. Я не несу ответственности за его поведение или правильность его ответов.",
  
  // Frameworks
  "Automatic detection": "Автоматическое определение",
  
  // A. Business Formation and Identity
  "MOC_COMPANIES_LAW": "A1. Закон о компаниях МТ",
  "MOC_PROFESSIONAL_COMPANIES_LAW": "A2. Закон о профессиональных компаниях МТ",
  "MOC_COMMERCIAL_REGISTER_LAW": "A3. Закон о коммерческом реестре МТ",
  "MOC_MINISTRY_OF_COMMERCE_LAW": "A4. Закон о Министерстве торговли",
  "MOC_TRADE_NAMES_LAW": "A5. Закон о торговых наименованиях МТ",
  "MOC_GCC_TRADEMARK_LAW": "A6. Закон о товарных знаках ССАГПЗ",
  
  // B. Financial Instruments, Security, and Insolvency
  "MOC_COMMERCIAL_PAPERS_LAW": "B1. Закон о коммерческих бумагах МТ",
  "MOC_COMMERCIAL_PLEDGE_LAW": "B2. Закон о коммерческом залоге МТ",
  "MOC_MOVABLE_PROPERTY_SECURITY_LAW": "B3. Закон об обеспечении движимого имущества МТ",
  "MOC_INSOLVENCY_LAW": "B4. Закон о несостоятельности МТ",
  
  // C. Commercial Relationships and Trade
  "MOC_COMMERCIAL_AGENCIES_LAW": "C1. Закон о коммерческих агентствах МТ",
  "MOC_FRANCHISE_LAW": "C2. Закон о франчайзинге МТ",
  "MOC_ECOMMERCE_LAW": "C3. Закон об электронной коммерции МТ",
  "MOC_CHAMBERS_OF_COMMERCE_LAW": "C4. Закон о торгово-промышленных палатах МТ",
  
  // D. Commercial Records and Information
  "MOC_COMMERCIAL_BOOKS_LAW": "D1. Закон о коммерческих книгах МТ",
  "MOC_COMMERCIAL_DATA_LAW": "D2. Закон о коммерческих данных МТ",
  "MOC_PUBLIC_WAREHOUSING_LAW": "D3. Закон о публичном складировании МТ",
  
  // E. Standards, Quality, and Regulated Products
  "MOC_STANDARDS_METROLOGY_LAW": "E1. Закон о стандартах и метрологии МТ",
  "MOC_CALIBRATION_MEASUREMENT_LAW": "E2. Закон о калибровке и измерениях МТ",
  "MOC_PRIVATE_LABORATORIES_LAW": "E3. Закон о частных лабораториях МТ",
  "MOC_PRECIOUS_METALS_GEMSTONES_LAW": "E4. Закон о драгоценных металлах и камнях МТ",
  "MOC_CHEMICALS_IMPORT_MANAGEMENT_LAW": "E5. Закон об управлении импортом химических веществ МТ",
  
  // F. Professional Regulation and Oversight
  "MOC_ACCOUNTING_AUDITING_LAW": "F1. Закон о бухгалтерском учете и аудите МТ",
  "MOC_VALUERS_LAW": "F2. Закон об оценщиках МТ",
  "MOC_ENGINEERS_LAW": "F3. Закон об инженерах МТ",
  
  // G. Compliance and Dispute Resolution
  "MOC_ANTI_CONCEALMENT_LAW": "G1. Закон о противодействии сокрытию МТ",
  "MOC_ANTI_MONEY_LAUNDERING_LAW": "G2. Закон о противодействии отмыванию денег МТ",
  "MOC_ARBITRATION_LAW": "G3. Закон об арбитраже МТ",
  "MOC_COMBATING_COMMERCIAL_ADULTERATION_LAW": "G4. Закон о борьбе с коммерческой фальсификацией МТ",
  "MOC_GCC_COMBATING_DUMPING_LAW": "G5. Закон ССАГПЗ о борьбе с демпингом",
  
  // Models
  "Claude by Anthropic": "Claude от Anthropic",
  "DeepSeek by Groq": "DeepSeek от Groq",
  "MJ Lab Mode": "Режим лаборатории MJ",
  
  // Character count
  "{{remainingChars}} character left": "Остался {{remainingChars}} символ",
  "{{remainingChars}} characters left": "Осталось {{remainingChars}} символов",
  
  // Error messages
  "An error occurred": "Произошла ошибка",
  "Failed to change language": "Не удалось изменить язык",
  "Please try again": "Пожалуйста, попробуйте снова",
  "Connection lost": "Соединение потеряно",
  "Reconnecting...": "Переподключение...",
  "Nothing to clear": "Нечего очищать",
  "All messages cleared": "Все сообщения удалены",
  "All data cleared": "Все данные удалены",
  "Storage limit reached": "Достигнут предел хранилища",
  "Some older messages were removed to save space.": "Некоторые старые сообщения были удалены для экономии места.",
  
  // Additional keys
  "Font Size": "Размер шрифта",
  "Language changed to {locale}": "Язык изменен на {locale}",
  "Select language": "Выберите язык",
  "Support": "Поддержка",
  
  // Brand names (do not translate)
  "Mila": "Mila",
  
  // Message actions
  "Message copied to clipboard": "Сообщение скопировано в буфер обмена",
  "Read": "Прочитать",
  "Summarize": "Обобщить",
  
  // Ice Breakers Dialog
  "Message Suggestions": "Предложения сообщений",
  "Select a question to quickly start a conversation about Saudi Ministry of Commerce laws.": "Выберите вопрос, чтобы быстро начать разговор о законах Министерства торговли Саудовской Аравии.",
  "What are the main requirements under the Companies Law for establishing a limited liability company in Saudi Arabia?": "Каковы основные требования согласно Закону о компаниях для создания общества с ограниченной ответственностью в Саудовской Аравии?",
  "How does the Commercial Agencies Law regulate relationships between foreign companies and Saudi agents?": "Как Закон о коммерческих агентствах регулирует отношения между иностранными компаниями и саудовскими агентами?",
  "What protections does the Saudi E-commerce Law provide for online consumers and businesses?": "Какую защиту предоставляет саудовский Закон об электронной коммерции для онлайн-потребителей и бизнеса?",
  
  // Audio Player Dialog
  "AI Summary": "Сводка ИИ",
  "Listen to the summarized response using our AI Service.": "Прослушайте краткий ответ с помощью нашего ИИ-сервиса.",
  "Generating summary...": "Создание сводки...",
  "Preparing audio...": "Подготовка аудио...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "Не удалось обработать текст. Пожалуйста, попробуйте снова.",
  "Failed to auto-play audio. Click play to try again.": "Не удалось автоматически воспроизвести аудио. Нажмите кнопку воспроизведения, чтобы попробовать снова.",
  "Failed to load audio. Please try again.": "Не удалось загрузить аудио. Пожалуйста, попробуйте снова.",
  "Audio playback was aborted.": "Воспроизведение аудио было прервано.",
  "Network error occurred while loading audio.": "Произошла сетевая ошибка при загрузке аудио.",
  "Audio decoding failed.": "Не удалось декодировать аудио.",
  "Audio format not supported.": "Формат аудио не поддерживается.",
  "Failed to setup audio playback": "Не удалось настроить воспроизведение аудио",
  "Failed to generate speech": "Не удалось сгенерировать речь",
  "Failed to generate audio. Please try again.": "Не удалось сгенерировать аудио. Пожалуйста, попробуйте снова.",
  "Failed to play audio. Please try again.": "Не удалось воспроизвести аудио. Пожалуйста, попробуйте снова."
};